import React from "react";
import PretendardText from "../../../../component/atoms/text/pretendardText";

const SalesEnvironmentCustomTooltip = ({ active, payload, dataType }) => {
  // 스타일 객체
  const circleStyle = {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
  };

  const getCellColor = (title) => {
    switch (title) {
      case "PC":
        return "#b658ff";
      case "Mobile":
        return "#46a196";
      case "신용카드":
        return "#cf6679";
      case "카카오페이":
        return "#ffa438";
      case "토스페이":
        return "#1b5ddd";
      case "네이버페이":
        return "#53bd20";
      default:
        return "#f3f3f3";
    }
  };

  if (active && payload && payload.length) {
    return (
      <div
        style={{
          width: "fit-content",
          height: "fit-content",
          backgroundColor: "#313233",
          padding: "10px 12px",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          boxShadow: "1px 1px 4px 0px rgba(0, 0, 0, 0.12)",
        }}
      >
        {dataType === "device" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <span
                style={{
                  ...circleStyle,
                  backgroundColor: getCellColor("PC"),
                }}
              />
              <PretendardText
                style={{
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "22.75px",
                  color: "#aaa",
                }}
              >
                PC
              </PretendardText>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <span
                style={{
                  ...circleStyle,
                  backgroundColor: getCellColor("Mobile"),
                }}
              />
              <PretendardText
                style={{
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "22.75px",
                  color: "#aaa",
                }}
              >
                Mobile
              </PretendardText>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <span
                style={{
                  ...circleStyle,
                  backgroundColor: getCellColor("신용카드"),
                }}
              />
              <PretendardText
                style={{
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "22.75px",
                  color: "#aaa",
                }}
              >
                체크·신용카드
              </PretendardText>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <span
                style={{
                  ...circleStyle,
                  backgroundColor: getCellColor("카카오페이"),
                }}
              />
              <PretendardText
                style={{
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "22.75px",
                  color: "#aaa",
                }}
              >
                카카오페이
              </PretendardText>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <span
                style={{
                  ...circleStyle,
                  backgroundColor: getCellColor("토스페이"),
                }}
              />
              <PretendardText
                style={{
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "22.75px",
                  color: "#aaa",
                }}
              >
                토스페이
              </PretendardText>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <span
                style={{
                  ...circleStyle,
                  backgroundColor: getCellColor("네이버페이"),
                }}
              />
              <PretendardText
                style={{
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "22.75px",
                  color: "#aaa",
                }}
              >
                네이버페이
              </PretendardText>
            </div>
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default SalesEnvironmentCustomTooltip;
